export const SECTION_ORDER_COOKIE_NAME = 'dashboard_surface_section_order'
export const HIDDEN_SECTIONS_COOKIE_NAME = 'dashboard_surface_hidden_sections'
export const COMPACT_MODE_COOKIE_NAME = 'dashboard_surface_compact_mode'
export const MAX_PR_AGE_COOKIE_NAME = 'dashboard_surface_max_pr_age'
